(function () {
  if (window.__brandTabsInit) {
    return;
  }
  window.__brandTabsInit = true;

  var PRESERVED_NAMES = ['q', 'options[prefix]'];

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;

      if (!target.classList || !target.classList.contains('brand-tabs__checkbox')) {
        return;
      }

      var willBeChecked = target.checked;
      var name = target.name;
      var value = target.value;

      var forms = document.querySelectorAll('[data-filter-form]');

      forms.forEach(function (form) {
        var inputs = form.querySelectorAll('input');

        inputs.forEach(function (input) {
          if (input === target) {
            return;
          }

          var isSameTab = input.classList.contains('brand-tabs__checkbox') && input.name === name && input.value === value;

          if (isSameTab) {
            input.checked = willBeChecked;
            return;
          }

          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = false;
            return;
          }

          if ((input.type === 'number' || input.type === 'text') && PRESERVED_NAMES.indexOf(input.name) === -1) {
            input.value = '';
          }
        });
      });
    },
    true
  );

  // A tab's metafield/value can also be registered as a plain filter, so the
  // same name+value may exist as a native filter-item checkbox elsewhere on
  // the page (e.g. a "Gender" filter group). Tab checkboxes intentionally
  // don't carry data-name-escaped/data-value-escaped (see brand-tabs.liquid),
  // so theme.js's cross-form syncForms() won't touch them — keep a tab's
  // checked state mirroring that native checkbox ourselves, in this direction
  // only. Toggling a tab already handles the other direction above.
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;

      if (!target.classList || target.classList.contains('brand-tabs__checkbox')) {
        return;
      }

      if (target.type !== 'checkbox' && target.type !== 'radio') {
        return;
      }

      var name = target.name;
      var value = target.value;
      var checked = target.checked;

      document.querySelectorAll('.brand-tabs__checkbox').forEach(function (tab) {
        if (tab.name === name && tab.value === value && tab.checked !== checked) {
          tab.checked = checked;
        }
      });
    },
    true
  );
})();
